import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";

export default function PartnerHero() {
  return (
    <section className="relative min-h-[66vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Proud%20South%20Indian%20farmer%20standing%20with%20arms%20crossed%20in%20front%20of%20a%20lush%20green%20farm%20at%20early%20morning%2C%20confident%20welcoming%20expression%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20dignified%20rural%20portrait%20in%20landscape%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=partner-hero&orientation=landscape"
          width={1920}
          height={1080}
          alt="Farmer standing proudly in front of his farm"
          title="Become a Rythugaru farm partner"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Become a Farm Partner</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            For Farmers
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Turn Your Farm Into a <span className="italic text-accent-300">Story People Travel For.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          Your farm already has everything — the fields, the seasons, the knowledge and the stories.
          We help you share it with visitors who want to learn where their food comes from, and earn
          a supplementary income while doing it.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mt-10">
          <a
            href="#partner-form"
            className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Apply to Partner
            <i className="ri-arrow-down-line"></i>
          </a>
          <Link
            to="/farmers"
            className="inline-flex items-center justify-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            Meet Our Farmers
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}